import type { WorkingTime, WorkingTimeDto } from '../types';

export function workingTimeFromDto(workingtime: WorkingTimeDto): WorkingTime {
  return {
    id: workingtime.id,
    weekDay: workingtime.dewt_weekday,
    starTimeMorning: workingtime.dewt_start_time_morning.slice(0, 5),
    endTimeMorning: workingtime.dewt_end_time_morning.slice(0, 5),
    startTimeAfternoon: workingtime.dewt_start_time_afternoon.slice(0, 5),
    endTimeAfternoon: workingtime.dewt_end_time_afternoon.slice(0, 5),
  };
}
